export default function () {
	const sectionTypes = { ceo: 'CEO section', risk: 'Risk section', gri: 'GRI section' }
	const exclusiveCSRDTypes = { 'sustainability statement': 'Sustainability statement', 'csrd reference table': 'CSRD reference table' }
	const CSRDSectionTypes = { ...sectionTypes, ...exclusiveCSRDTypes }

	let existingSections = []

	function concatSection(section) {
		return `${section.section_type}_${section.start}_${section.end}`
	}

	function checkIfCSRD(documentType) {
		return documentType?.toLowerCase().includes('csrd')
	}

	return {
		checkIfCSRD,
		getSectionTypes: (documentType) => (checkIfCSRD(documentType) ? CSRDSectionTypes : sectionTypes),
		createSectionDataTypeDict: (sections, isCSRD) => {
			/**
			 * Receives sections as an array of objects as follows:
			 * sections = [{section_type: 'ceo', start: 1, end: 2}, {section_type: 'risk', start: 3, end: 4}]
			 * Returns an object with the following structure:
			 * {ceo: [{section_type: 'ceo', start: 1, end: 2}], risk: [{section_type: 'risk', start: 3, end: 4}]}
			 *  */
			const sectionsData = {}
			existingSections = [...sections]
			for (const sectionType in isCSRD ? CSRDSectionTypes : sectionTypes) {
				sectionsData[sectionType] = sections?.filter((section) => section.section_type === sectionType)
			}
			return sectionsData
		},
		createSectionDataArray: (sectionsData) => Object.values(sectionsData || []).flat(),

		getSectionDiffs: (currentSections) => {
			const existingSet = new Set(existingSections.map((s) => concatSection(s)))
			const currentSet = new Set(currentSections.map((s) => concatSection(s)))

			return {
				added: currentSections.filter((s) => !existingSet.has(concatSection(s))),
				deleted: existingSections.filter((s) => !currentSet.has(concatSection(s)))
			}
		},
		getExclusiveCSRDTypes: () => Object.keys(exclusiveCSRDTypes)
	}
}
